// **React Imports
import { memo, useMemo } from 'react'

// ** MUI Imports
import {
  Box,
  LinearProgress,
  linearProgressClasses,
  styled,
  Tooltip,
  Typography
} from '@mui/material'

// **Third party Imports
import { Link } from 'react-router-dom'

// ** SCSS Imports
import './index.scss'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 7,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[300]
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: 'var(--badge-color)'
  }
}))

const ScoreBadge = ({
  acquired,
  total,
  sx = {},
  link = null,
  title = '',
  state = null
}) => {
  // variables
  const percentage = useMemo(
    () => (total > 0 ? Math.floor((acquired / total) * 100) : 0),
    [acquired, total]
  )

  const renderBadge = useMemo(
    () => (
      <Tooltip title={link ? title : ''} arrow>
        <Box
          className={`score-badge ${
            percentage > 70
              ? 'high-grades'
              : percentage > 40
              ? 'medium-grades'
              : 'low-grades'
          }`}
        >
          <Box className="score-count">
            <Typography component={'span'} className="acquired-marks">
              {acquired}
            </Typography>
            <Typography component={'span'} className="total-marks">
              /{total}
            </Typography>
          </Box>
          <BorderLinearProgress
            className="score-progress"
            variant="determinate"
            value={percentage}
          />
        </Box>
      </Tooltip>
    ),
    [percentage, acquired, total, title, link]
  )

  return (
    <Box
      className="score-container"
      sx={{ cursor: link ? 'pointer' : 'default', ...sx }}
    >
      {link ? (
        <Link to={link} state={state}>
          {renderBadge}
        </Link>
      ) : (
        renderBadge
      )}
    </Box>
  )
}

export default memo(ScoreBadge)
